import { SelectProps } from "@cofano/cck/Select/Select";
import { DemurrageCalculationUnit } from "__generated__/graphql";
import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";

const DemurrageCalculationUnitSelect = ({ value, onChange }: Omit<SelectProps<DemurrageCalculationUnit, false>, "fetchOptions">) => {
	return (
		<Select
			fetchOptions={Object.values(DemurrageCalculationUnit)}
			getOptionLabel={(option) => intl.formatMessage({ id: `DEMURRAGE_CALCULATION_UNIT_${option}` })}
			value={value}
			onChange={onChange}
		/>
	);
};

export default DemurrageCalculationUnitSelect;
